import React, { useEffect } from "react";
import './App.css';
import Routes from "./Routes";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration (default is 400ms)
      offset: 100, // Offset (in px) from the original trigger point
      easing: "ease-in-out", // Easing function
      once: false, // Whether animation should happen only once
    });
  }, []);
  return (
    <div className="App">
      <div className="App">
      <Routes />
    </div>
    </div>
  );
}

export default App;
